function load(component) {
    return () =>import (`@/components/${component}.vue`);
};
export default {
    path:"logistics",
    component:load("logistics/layout"),
    children:[
        {
            path:"",
            name:"logistics",
            component:load("logistics/index"),
            meta: {
                parent: 'logistics',
                child: 'dispatching',
                deal: true
            }
        },
        {
            path:"create",
            name:"logistics-create",
            component:load("logistics/create"),
            meta: {
                parent: 'logistics',
                child: 'dispatching',
                deal: false
            }
        },
        {
            path:"details/:id",
            name:"logistics-details",
            component:load("logistics/details"),
            meta: {
                parent: 'logistics',
                child: 'dispatching',
                deal: true
            }
        }
    ],
};



// WEBPACK FOOTER //
// ./src/components/logistics/route/index.js